import moment from "moment-timezone";

export const cardData = [
    {
        jobNumber: 1,
        content: "I'll pick it up"
    },
    { jobNumber: 2, content: 'Someone else will' }
];

export const obj1 = [
    {
        label: '9:00am',
        value: '9:00am'
    },
    {
        label: '10:00am',
        value: '10:00am'
    },
    {
        label: '11:00am',
        value: '11:00am'
    }
];

export const obj2 = [
    {
        label: '1:00pm',
        value: '1:00pm'
    },
    {
        label: '2:00pm',
        value: '2:00pm'
    },
    {
        label: '3:00pm',
        value: '4:00pm'
    }
];

export const getTimeWindowValue = (chooseTime, storeStartTime, storeCloseTime) => {
    const formattedChooseTime = moment(chooseTime, 'hh:mm');
    const formattedStoreStartTime = moment(storeStartTime, 'hh:mm');
    const formattedStoreCloseTime = moment(storeCloseTime, 'hh:mm');

    if (formattedChooseTime.isBefore(formattedStoreStartTime)) {
        return 1;
    } else if (formattedChooseTime.isAfter(formattedStoreCloseTime)) {
        return 2;
    } else {
        return 0;
    }
};

export const WITHIN_WINDOW = 0;
export const BEFORE_WINDOW = 1;
export const AFTER_WINDOW = 2;

export const crossIconSvg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEiSURBVHgB7ZVLbsIwFEWv0y6gw44rug9aBdbRHbRdAMIICZgBS2AXIPGdsQlYAywAGxvxiZDJtSEzfAZJlDznHfn52UAkEnl2XmhEq9rF98cQlRIwWS3gQ6fyiy8zJi29mzGjvNAEDK1+DnelJdrVOo23MTv0APEGrf9YuIcAGudnJmG/2ZhLfAMEXoLpemmmU0CI8lGo7CyHK3ltLNnvuYBltp7nStyZ3CIQQjOVSMSlBImQx4TynuThAi6JLIHJLX4lyHJdjgeSW3gXuHhNtNc7D8Jn4HrBnbjVHYUKuFa7xoK2aCECt1qNtWghAqzPH5DgAr6bjEsi/dwaiSVy4F0QssnYb9n9Xyt6eHkIqL65bszJ9u/V51kJhQEikUiEsAevLrT2X/135AAAAABJRU5ErkJggg=="
export const crossBlackSvg = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M17.8857 15.9998L23.6097 10.2758C24.131 9.75451 24.131 8.91185 23.6097 8.39051C23.0883 7.86918 22.2457 7.86918 21.7243 8.39051L16.0003 14.1145L10.2763 8.39051C9.755 7.86918 8.91233 7.86918 8.391 8.39051C7.86967 8.91185 7.86967 9.75451 8.391 10.2758L14.115 15.9998L8.391 21.7238C7.86967 22.2452 7.86967 23.0878 8.391 23.6092C8.651 23.8692 8.99233 23.9998 9.33367 23.9998C9.675 23.9998 10.0163 23.8692 10.2763 23.6092L16.0003 17.8852L21.7243 23.6092C21.9843 23.8692 22.3257 23.9998 22.667 23.9998C23.0083 23.9998 23.3497 23.8692 23.6097 23.6092C24.131 23.0878 24.131 22.2452 23.6097 21.7238L17.8857 15.9998Z"
    fill="#1C1C1C"/>
</svg>`
